



import { Component, Vue } from 'vue-property-decorator';
import LaserPointerIcon from '../../assets/laser.svg?inline';
@Component({
  components: {
    LaserPointerIcon,
  },
})
export default class LaserIcon extends Vue {}
